<div class="scaffold-sidebar-overlay">
  <div style="display:flex;">
    <div style="flex:1;">
      <div class="scaffold-editor-panel-heading">{{'comments'| translation}}</div>
      <div class="scaffold-editor-panel-sub-heading">
        {{label}}
      </div>

    </div>
    <div><p-button variant="text" size='large' (click)="close()" severity="info" aria-label="Close comments panel"><i class="fas fa-times"></i></p-button></div>
  </div>
  <hr />
  <div class="sidebar-scroll-area">
    <app-comments-board [info]="info" [item]="item"></app-comments-board>
  </div>
  </div>
